
import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TokenInterceptor } from "app/authorized-http.service";
import { UtilsService } from "app/services/utils.service";
import { NewsletterScheduleResource } from "app/models/NewsletterScheduleResource";
import { Observable } from "rxjs";
import { Http, Response } from "@angular/http";
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";

@Injectable()
export class NewsletterSettingsService {

  userEmail = localStorage.getItem("_user");

  constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

  saveNewsletterSchedule(body): Observable<NewsletterScheduleResource> {
    return this.http.post<NewsletterScheduleResource>(environment['url'] + '/admin/newsletter/schedule/edit', body)
  }

  getNewsletterSchedule(): Observable<NewsletterScheduleResource> {
    return this.http.get<NewsletterScheduleResource> (environment['url'] + '/admin/newsletter/schedule/getFirst?userEmail='+this.userEmail)
  }

  private NewsletterScheduleResource(res: Response) {
    let body = res.json()
    return body || [] // returneaza vector gol
  }
}
